import React, { useMemo } from 'react';
import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { MUIDataTableColumnDef } from 'mui-datatables';
import CustomDialog, {
  CustomDialogProps,
} from '../../../../components/CustomDialog';
import CustomDataTable from '../../../../components/CustomDataTable';
import { ChartDetailDTO } from '../../../../models/dto/SystemAdherenceDTO';
import SYSTEM_ADHERENCE_DATA_ENUM, {
  FUNCIONARIOS,
} from '../../../../models/enum/SystemAdherenceDataEnum';
import { getEnumLabel } from '../../../../models/enum/BaseEnum';

export interface SystemAdherenceTableDialogProps extends CustomDialogProps {
  type: string;
  loading: boolean;
  systemAdherenceData: ChartDetailDTO[];
}

const SystemAdherenceTableDialog: React.FC<SystemAdherenceTableDialogProps> = ({
  type,
  systemAdherenceData,
  loading,
  ...rest
}: SystemAdherenceTableDialogProps) => {
  const columns = useMemo((): MUIDataTableColumnDef[] => {
    const tableColumns = [
      {
        name: 'regional',
        label: 'Referência',
      },
      {
        name: 'razao',
        label: 'Nome do Condominio',
      },
      {
        name: 'carteira',
        label: 'Carteira',
      },
      {
        name: 'filialNome',
        label: 'Filial',
      },
      {
        name: 'inicio',
        label: 'Data de Início do Ponto',
      },
    ];
    if (type === FUNCIONARIOS.value) {
      tableColumns.push(
        {
          name: 'nome',
          label: 'Nome do Colaborador',
        },
        {
          name: 'cadastro',
          label: 'Matrícula',
        },
        {
          name: 'status',
          label: 'Status',
        },
      );
    }
    return tableColumns;
  }, [type]);

  return (
    <CustomDialog
      {...rest}
      showOneButton
      maxWidth="lg"
      okButtonLabel="Fechar"
      showCloseButton
    >
      <CustomDataTable
        title={
          <Grid container direction="row">
            <Typography variant="h6">
              {`Adesão ao Ponto Digital - ${getEnumLabel(
                type,
                SYSTEM_ADHERENCE_DATA_ENUM,
              )}`}
            </Typography>
            {loading && (
              <CircularProgress
                size={20}
                style={{ marginLeft: 15, position: 'relative', top: 4 }}
              />
            )}
          </Grid>
        }
        data={systemAdherenceData}
        columns={columns}
        options={{ elevation: 0, download: true }}
      />
    </CustomDialog>
  );
};

export default SystemAdherenceTableDialog;
